<template>
  <div class="cellLinkType">
    <div v-if="conditionsDict && conditionsDict.length">
      <span @click.stop="handleClick" @click.middle.stop="handleMiddleClick" class="cursor-pointer">
        <div v-html="getValueFromCondition" :active="value" :title="value" class="cellLinkType__div-text" />
      </span>
    </div>
    <div v-if="!conditionsDict || conditionsDict.length == 0">
      <span @click.stop="handleClick" @click.middle.stop="handleMiddleClick" class="cursor-pointer">
        <span :class="iconClass" />
        <span> {{ formattedValue }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import genericTableService from '@/services/genericConfig/genericTable.utils.js';
/**
 * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS BOTONES
 * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
 * */
export default {
  name: 'cell-dt-link-type',

  data() {
    return {
      defaultClass: 'mdi mdi-link-variant',
    };
  },

  props: ['value', 'conditionsDict', 'index', 'readTransform', 'format', 'currency', 'area', 'frequency', 'precedent', 'col', 'disabled'],

  computed: {
    formattedValue() {
      let formatVal;
      if (this.value && this.readTransform) {
        formatVal = genericTableService.getReadTransform(this.value, this.readTransform) || this.value;
      }
      if (this.format) {
        formatVal = genericTableService.getFormatAndSuffix(this.currency, this.area, this.frequency, this.precedent, formatVal || this.value, this.format);
      }
      return formatVal || this.value;
    },
    getValueFromCondition() {
      let found = false;
      let index = 0;
      // Eval expression
      while (!found && index < this.conditionsDict.length) {
        found = this.$parent.fnEvalCondition(this.conditionsDict[index].ValueCondition, this.formattedValue, this.index);
        if (!found) {
          index += 1;
        }
      }
      // Get value if meet condition
      if (found) {
        return this.conditionsDict[index].Value.replace('{{value}}', this.formattedValue !== undefined && this.formattedValue != null ? this.formattedValue : '');
      }
      return null;
    },
    iconClass() {
      const { EmitEventName } = this.col;

      if (['fnEditMandate', 'fnEditDocument', 'fnUpdateUser', 'fnUpdateProfile', 'fnUpdateRole'].includes(EmitEventName)) {
        return 'mdi mdi-pencil';
      }

      if (EmitEventName === 'fnGoToMandate') {
        return '';
      }

      if (EmitEventName === 'fnRestoreMandate') {
        return 'mdi mdi-backup-restore';
      }

      if (['deleteRow', 'fnDeleteMandate', 'fnDeleteDocument', 'fnDeleteUser', 'fnDeleteProfile', 'fnDeleteRole', 'fnRemoveAssociatedRole'].includes(EmitEventName)) {
        return 'mdi mdi-trash-can-outline';
      }

      if (EmitEventName === 'showAuditLog') {
        return 'mdi mdi-video';
      }

      return 'mdi mdi-link-variant';
    },
  },

  methods: {
    handleClick(e) {
      e.preventDefault();
      if (!this.disabled) {
        this.$emit('btn-click', e);
      }
    },

    handleMiddleClick(e) {
      this.handleClick(e);
    },
  },
};
</script>

<style scoped>
.cellLinkType {
  text-align: center;
}

.cursor-pointer {
  cursor: pointer;
}

.cellLinkType a {
  color: #35495e;
}

.cellLinkType div[active='true'] >>> .mdi-star {
  color: #f4c129;
}
</style>
